<template>
    <button class="slider-btn">
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path
                v-if="btnType === 'next'"
                d="M19.6916 10.1787L19.6916 15.7008L7.37737 15.7008L7.33596 18.4756L19.6916 18.4756L19.6916 23.9839L26.5942 17.0813L19.6916 10.1787Z"
                fill="#6B3084"
            />
            <path
                v-else
                d="M14.3084 23.8213L14.3084 18.2992L26.6227 18.2992L26.6641 15.5244L14.3084 15.5244L14.3084 10.0161L7.40582 16.9187L14.3084 23.8213Z"
                fill="#6B3084"
            />
        </svg>
    </button>
</template>

<script setup lang="ts">
const { btnType } = defineProps<{ btnType: 'next' | 'prev' }>();
</script>

<style lang="postcss" scoped>
.slider-btn {
    @apply h-10 w-10 sm:h-12 sm:w-12 rounded-full bg-white z-10 flex items-center justify-center;
    filter: drop-shadow(0px 0px 8px rgba(131, 126, 126, 0.2));
}
</style>
